import { CalendarCheckIcon, CheckCircle2, HandshakeIcon, PhoneCallIcon, UsersIcon } from "lucide-react";

import { TotalizersGrid } from "@/modules/common/components";
import { LeadStatus } from "@/modules/common/types/Leads.enum";
import { LeadSummaryResponse } from "@/service/response/admin-leads";

interface LeadsTotalizersProps {
  data?: LeadSummaryResponse;
  isLoading?: boolean;
}

const LeadsTotalizers = ({ data, isLoading = false }: LeadsTotalizersProps) => (
  <TotalizersGrid
    className="md:grid-cols-5"
    isLoading={isLoading}
    items={[
      {
        key: "total",
        title: "Total de leads",
        value: data?.total,
        icon: <UsersIcon className="w-5 h-5 text-blue-900 font-bold" />,
        iconWrapperClassName: "bg-sky-800/20",
      },
      {
        key: "in-contact",
        title: "Em contato",
        value: data?.byStatus[LeadStatus.IN_CONTACT],
        icon: <PhoneCallIcon className="w-5 h-5 text-amber-600 font-bold" />,
        iconWrapperClassName: "bg-amber-100",
      },
      {
        key: "demo-scheduled",
        title: "Demonstrações agendadas",
        value: data?.byStatus[LeadStatus.DEMO_SCHEDULED],
        icon: <CalendarCheckIcon className="w-5 h-5 text-blue-900 font-bold" />,
        iconWrapperClassName: "bg-sky-800/20",
      },
      {
        key: "in-negotiation",
        title: "Em negociação",
        value: data?.byStatus[LeadStatus.IN_NEGOTIATION],
        icon: <HandshakeIcon className="w-5 h-5 text-purple-700 font-bold" />,
        iconWrapperClassName: "bg-purple-100",
      },
      {
        key: "converted",
        title: "Convertidos",
        value: data?.byStatus[LeadStatus.CONVERTED],
        icon: <CheckCircle2 className="w-5 h-5 text-green-500 font-bold" />,
        iconWrapperClassName: "bg-emerald-100",
      },
    ]}
  />
);

export default LeadsTotalizers;
